<template>
    <v-app-bar
            app
            color="blue-grey lighten-3"
    >
        <v-toolbar-title>AB Testing Panel</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn
                fab
                small
                dark
                color="grey darken-3"
                to="/"
        >
            <v-icon dark>mdi-magnify</v-icon>
        </v-btn>

        <div v-if="!authIsLoading()" class="ml-4">
            <v-btn
                    v-if="userIsAuthenticated()"
                    @click="logout"
            >
                Log Out
            </v-btn>
            <v-btn
                    v-else
                    @click="login"
            >
                Log In
            </v-btn>
        </div>

    </v-app-bar>
</template>

<script>
    export default {
        name: 'NavBar',
        methods: {
            // Log the user in
            login() {
                this.$auth.loginWithRedirect();
            },
            // Log the user out
            logout() {
                this.$auth.logout({
                    returnTo: window.location.origin
                });
            },
            // Check if auth is loading
            authIsLoading() {
                return this.$auth.loading
            },
            // Check if user is authenticated
            userIsAuthenticated() {
                return this.$auth.isAuthenticated
            }
        }
    }
</script>